/**
 * Rounds a coordinate before it is looked up.
 *
 * Shared by the two location lookups in this folder, `useGeocode` and
 * `useW3w`, which each carried their own private copy of it before. It is a
 * pure helper, so `../util` is its natural home; it sits here for now because
 * both its callers do, and it is deliberately kept out of the barrel.
 */
export function preprocessCoord(coord: number): number {
    // 4 decimal places to an accuracy of 11.1m (https://en.wikipedia.org/wiki/Decimal_degrees)
    return parseFloat(coord.toFixed(4));
}
